import {ApplicationRef, ComponentFactoryResolver, Injectable, Injector} from '@angular/core';
import {NgElement, WithProperties} from "@angular/elements";
import {CatalogComponent} from "../../components/catalog/catalog.component";

/**
 * This way of injecting into the Knockout pages may not be necessary.
 */
@Injectable({
  providedIn: 'root'
})
export class CatalogCustomElementService {

  constructor(private injector: Injector,
              private applicationRef: ApplicationRef,
              private componentFactoryResolver: ComponentFactoryResolver) {
    // Share the service with the Knockout side by putting it on window
    (window as any).SHARED_SERVICE_CATALOG  = this;
  }

  showAsElement(message: string) {
    // Create element
    const catalogEl: NgElement & WithProperties<CatalogComponent> = document.createElement('sb-catalog') as any;

    // Add to the DOM
    let element = document.getElementById("sb-catalog");
    element.appendChild(catalogEl);
  }
}
